<template>
    <AppView title="重設密碼" :footerShow="false">
        <main class="min-h-app bg-gray-50 pb-24">
            <section class="border-b border-gray-100 bg-white px-5 py-6">
                <p class="text-xs font-medium text-gray-400">帳號安全</p>
                <h1 class="mt-2 text-xl font-bold text-gray-900">重設登入密碼</h1>
                <p class="mt-2 text-sm leading-6 text-gray-500">
                    請輸入會員電話並完成短訊認證，再設定新的登入密碼。
                </p>
            </section>

            <form
                class="mt-2 border-y border-gray-100 bg-white px-5 py-5"
                @submit.prevent="submit"
            >
                <h2 class="mb-5 text-sm font-bold text-gray-900">會員電話</h2>
                <div class="grid grid-cols-5 gap-x-3">
                    <FieldWithLabel
                        id="country_code"
                        class="col-span-2"
                        label="區號"
                        placeholder="電話區號"
                        v-model="form.country_code"
                        type="select"
                        :disabled="submitting"
                        :options="countryCodeOptions"
                    />
                    <FieldWithLabel
                        id="tel"
                        class="col-span-3"
                        v-model="form.tel"
                        label="電話號碼"
                        placeholder="聯絡電話"
                        :disabled="submitting"
                    />
                </div>

                <VerifyTelField
                    v-model="form['tel_verify_code']"
                    id="tel_verify_code"
                    label="短訊認證碼"
                    placeholder="短訊認證碼"
                    :tel="form.tel"
                    :code="form.country_code"
                    :authtype="form.type"
                    :disabled="submitting"
                />

                <FieldWithLabel
                    id="password"
                    type="password"
                    v-model="form['password']"
                    label="新密碼"
                    placeholder="請輸入密碼"
                    :disabled="submitting"
                />

                <FieldWithLabel
                    id="password_confirmation"
                    type="password"
                    v-model="form['password_confirmation']"
                    label="確認新密碼"
                    placeholder="請再次輸入密碼"
                    :disabled="submitting"
                />

                <button type="submit" class="btn h-12 w-full text-base" :disabled="submitting">
                    確定
                </button>
                <p class="mt-5 text-center text-sm text-primary">
                    <nuxt-link :to="localePath('/auth/login')">返回會員登入</nuxt-link>
                </p>
            </form>
        </main>
    </AppView>
</template>

<script>
export default {
    auth: false,
    data() {
        return {
            form: {
                type: "forgot",
                country_code: this.defaultCountryCode,
                tel: "",
            },
            submitting: false,
        };
    },
    methods: {
        async submit() {
            if (this.submitting) return;
            try {
                this.submitting = true;
                this.$loader.load();
                await this.$axios.post("/api/forgot", this.form);
                this.$loader.success("密碼已重設");
                this.$router.push("/auth/login");
            } catch (e) {
                console.error(e);
                this.$loader.error();
                this.submitting = false;
            }
        },
    },
};
</script>
